// import gqmsUtils from '@/views/gqmsCommUtil/api'; //공통함수 import
import { rootComputed } from '@/store/common/helpers';
import { setLpad, setChartBgColor, setChartBdColor } from '@/qmsUtils/'; //공통함수 import
import moment from 'moment';

export default {
	dayCols_: (state, getters, rootState, rootGetters) => {
		let cols = [];
		let searcCuRslt = Number(state.searchParams.searchDate);
		let thisYear = moment().format('YYYY');
		let searchYear = searcCuRslt.toString();

		let cpnyCd = {
			label: `${rootGetters['commonStore/getMessage_']('\u00A0')}`, //Total
			// label: `getMessage_('\u00A0')`,
			prop: 'cpnyCd',
			width: '120px',
			sortable: false
		};
		let cpnyNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC002065')}`, //법인
			prop: 'cpnyNm',
			width: '120px',
			sortable: false
		};
		let totCnt = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001282')}`, //전체
			prop: 'totCnt',
			minWidth: '100px',
			sortable: false
		};
		let vCnt = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001685')}`, //LP
			prop: 'vcnt',
			minWidth: '50px',
			sortable: false
		};

		let kd1 = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001686')}`, // KD
			minWidth: '150px',
			align: 'center',
			sortable: false,
			children: [
				{
					label: `${rootGetters['commonStore/getMessage_']('QWCC002078')}`, //총합계
					prop: 'kdTotCnt',
					minWidth: '50px',
					sortable: false
				},
				{
					label: `${rootGetters['commonStore/getMessage_']('QWCC001688')}`, //한국
					prop: 'kcnt',
					minWidth: '50px',
					sortable: false
				},
				{
					label: `${rootGetters['commonStore/getMessage_']('QWCC001687')}`, //기타
					prop: 'xcnt',
					minWidth: '50px',
					sortable: false
				}
			]
		};
		let mipCnt = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC002077')}`, //MIP
			prop: 'mipcnt',
			minWidth: '50px',
			sortable: false
		};
		let mCnt = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001689')}`, //미분류
			prop: 'mcnt',
			minWidth: '100px',
			sortable: false
		};

		cols.push(cpnyCd);
		cols.push(cpnyNm);
		cols.push(totCnt);
		cols.push(vCnt);
		cols.push(kd1);
		cols.push(mipCnt)
		cols.push(mCnt);

		//console.log('값은>>>>>', cols);

		return cols;
	},
	//라인 차트
	LineChartLabel_: (state, getters, rootState, rootGetters) => {
		let cols = [];
		let searcCuRslt = Number(state.searchParams.searchDate);
		let cuRsltLabel = searcCuRslt.toString().substring(2, 4) + `${rootGetters['commonStore/getMessage_']('QWCC001451')}` + ' ';
		let thisYear = moment().format('YYYY');
		let searchYear = searcCuRslt.toString();

		let startMonth = state.searchParams.strtMm02;
		let endMonth = state.searchParams.endMm02;
		let strYr = moment(startMonth).year();
		let strMo = moment(startMonth).month();
		let diffMonth = moment(endMonth).diff(moment(startMonth), 'months');

		let propI = 0;
		for (let i = strMo; i < diffMonth + 1; i++) {
			const year = strYr + Math.floor(i / 12) + '';
			const month = (i % 12) + 1;
			const newColLabel =
				year +
				`${rootGetters['commonStore/getMessage_']('QWCC001451')}` +
				' ' +
				setLpad(month, 2, '0') +
				`${rootGetters['commonStore/getMessage_']('SWCC000365')}`;
			propI++;
			cols.push(newColLabel);
		}
		return cols;
	},
	//라인 차트 데이터
	lineDataSet_: state => {
		let startMonth = state.searchParams.strtMm02;
		let endMonth = state.searchParams.endMm02;

		let graphLineChartInfo = state.graphLineChartInfo;
		///let strYr = moment(startMonth).year();
		let strMo = moment(startMonth).month();
		let diffMonth = moment(endMonth).diff(moment(startMonth), 'months');

		let fromMonth = diffMonth + 1;

		//console.log('strMo>>>>', strMo);
		//console.log('diffMonth>>>>', diffMonth);

		//console.log('graphLineChartInfo>>>>', graphLineChartInfo);
		let cols = [];

		let colsData = [];
		let bgColor = [];
		let tmpLabel = '';
		let carCd = [];
		let partType = [];
		let tmpCarCd = [];
		let tmpPartType = [];
		let newCol = {};

		//데이터를 만든다.
		for (let i = 0; i < graphLineChartInfo.length; i++) {
			if (tmpPartType != graphLineChartInfo[i].partType) {
				partType.push(graphLineChartInfo[i].partType);
				tmpPartType = graphLineChartInfo[i].partType;
			}
		}

		for (let j = 0; j < partType.length; j++) {
			for (let y = 1; y <= fromMonth; y++) {
				if (y < 10) {
					colsData.push(graphLineChartInfo[j]['mm0' + y]);
					tmpLabel = graphLineChartInfo[j].partTypeNm;
				} else {
					colsData.push(graphLineChartInfo[j]['mm' + y]);
					tmpLabel = graphLineChartInfo[j].partTypeNm;
				}
			}

			let newCol = {
				label: tmpLabel,
				data: colsData,
				borderColor: setChartBdColor(j)
			};
			//데이터 및 라벨을 초기화해야됨.
			colsData = [];
			tmpLabel = '';
			cols.push(newCol);
		} // end j

		return cols;
	}
};
